import React, {Component} from 'react';

class Home extends Component{

  constructor(props){
    super(props);
    this.state = {
        data: []
    };
  }

  componentDidMount() {
    fetch(`${process.env.PUBLIC_URL}/data/dataset.json`)
    .then(response => response.json())
    .then(dataset => this.setState({
      data: dataset 
    }));
  }

  render(){
    return(
      <div className="container-fluid">
        <div className="row justify-content-center p-4">
          <div className="card">
            <div className="card-body">
              <p><i className="fas fa-check" aria-hidden="true"></i> Refactoring tasks completed successfully.</p>
              <p><i className="fas fa-times reficoncolor" aria-hidden="true"></i> Refactoring tasks performed with mistakes.</p>
            </div>
          </div>
        </div>
        
        <div className="row justify-content-center">
          <div className="col-auto">
            <table className="table table-sm table-responsive table-bordered font-weight-light">
              <thead className="">
                
                <tr>
                  <th className="text-center align-middle" rowSpan={2} scope="col" >Student</th>
                  <th className="text-center align-middle" rowSpan={2} scope="col">Refactoring Operations</th>
                  <th className="text-center" colSpan={16} scope="col">Explicit Guidelines</th>
                  <th className="text-center" colSpan={4} scope="col">Flexible Guidelines</th>
                </tr>
                <tr>
                  {/* <th className="text-center" rowSpan={1} scope="col">#</th> */}
                  {/* <th className="text-center" scope="col">Mistakes</th> */}
                  <th className="text-center" scope="col">Mistakes</th>
                  <th className="text-center" scope="col">1</th>
                  <th className="text-center" scope="col">2</th>
                  <th className="text-center" scope="col">3</th>
                  <th className="text-center" scope="col">4</th>
                  <th className="text-center" scope="col">5</th>
                  <th className="text-center" scope="col">6</th>
                  <th className="text-center" scope="col">7</th>
                  <th className="text-center" scope="col">8</th>
                  <th className="text-center" scope="col">9</th>
                  <th className="text-center" scope="col">10</th>
                  <th className="text-center" scope="col">11</th>
                  <th className="text-center" scope="col">12</th>
                  <th className="text-center" scope="col">13</th>
                  <th className="text-center" scope="col">14</th>
                  <th className="text-center" scope="col">15</th>
                  <th className="text-center" scope="col">Mistakes</th>
                  <th className="text-center" scope="col">16</th>
                  <th className="text-center" scope="col">17</th>
                  <th className="text-center" scope="col">18</th>
                  
                </tr>
              </thead>
              <tbody>
                  {this.state.data.map((student, index) => {
                    return(
                      <tr key={index}>
                        <td className="text-center">{student.cod}</td>
                        <td className="text-center"><a key={index} href={`${process.env.PUBLIC_URL}/#/refactoring/${student.cod}`} rel="noopener noreferrer">link</a></td>
                        <td className="text-center">{student.mistakes_explicit_guidelines}</td>
                        <td>{student.task1 === "ok" ? <i className="fas fa-check" aria-hidden="true"></i> : <i className="fas fa-times reficoncolor" aria-hidden="true"></i>}</td>
                        <td>{student.task2 === "ok" ? <i className="fas fa-check" aria-hidden="true"></i> : <i className="fas fa-times reficoncolor" aria-hidden="true"></i>}</td>
                        <td>{student.task3 === "ok" ? <i className="fas fa-check" aria-hidden="true"></i> : <i className="fas fa-times reficoncolor" aria-hidden="true"></i>}</td>
                        <td>{student.task4 === "ok" ? <i className="fas fa-check" aria-hidden="true"></i> : <i className="fas fa-times reficoncolor" aria-hidden="true"></i>}</td>
                        <td>{student.task5 === "ok" ? <i className="fas fa-check" aria-hidden="true"></i> : <i className="fas fa-times reficoncolor" aria-hidden="true"></i>}</td>
                        <td>{student.task6 === "ok" ? <i className="fas fa-check" aria-hidden="true"></i> : <i className="fas fa-times reficoncolor" aria-hidden="true"></i>}</td>
                        <td>{student.task7 === "ok" ? <i className="fas fa-check" aria-hidden="true"></i> : <i className="fas fa-times reficoncolor" aria-hidden="true"></i>}</td>
                        <td>{student.task8 === "ok" ? <i className="fas fa-check" aria-hidden="true"></i> : <i className="fas fa-times reficoncolor" aria-hidden="true"></i>}</td>
                        <td>{student.task9 === "ok" ? <i className="fas fa-check" aria-hidden="true"></i> : <i className="fas fa-times reficoncolor" aria-hidden="true"></i>}</td>
                        <td>{student.task10 === "ok" ? <i className="fas fa-check" aria-hidden="true"></i> : <i className="fas fa-times reficoncolor" aria-hidden="true"></i>}</td>
                        <td>{student.task11 === "ok" ? <i className="fas fa-check" aria-hidden="true"></i> : <i className="fas fa-times reficoncolor" aria-hidden="true"></i>}</td>
                        <td>{student.task12 === "ok" ? <i className="fas fa-check" aria-hidden="true"></i> : <i className="fas fa-times reficoncolor" aria-hidden="true"></i>}</td>
                        <td>{student.task13 === "ok" ? <i className="fas fa-check" aria-hidden="true"></i> : <i className="fas fa-times reficoncolor" aria-hidden="true"></i>}</td>
                        <td>{student.task14 === "ok" ? <i className="fas fa-check" aria-hidden="true"></i> : <i className="fas fa-times reficoncolor" aria-hidden="true"></i>}</td>
                        <td>{student.task15 === "ok" ? <i className="fas fa-check" aria-hidden="true"></i> : <i className="fas fa-times reficoncolor" aria-hidden="true"></i>}</td>
                        <td className="text-center">{student.mistakes_flexible_guidelines}</td>
                        <td>{student.task16 === "ok" ? <i className="fas fa-check" aria-hidden="true"></i> : <i className="fas fa-times reficoncolor" aria-hidden="true"></i>}</td>
                        <td>{student.task17 === "ok" ? <i className="fas fa-check" aria-hidden="true"></i> : <i className="fas fa-times reficoncolor" aria-hidden="true"></i>}</td>
                        <td>{student.task18 === "ok" ? <i className="fas fa-check" aria-hidden="true"></i> : <i className="fas fa-times reficoncolor" aria-hidden="true"></i>}</td>
                      </tr>)
                  })}
              </tbody>
            </table>
            
          </div>
        </div>

        

      </div>
    )
  }
}

export default Home;